import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { faCalendarAlt, faTimes, faLink } from '@fortawesome/free-solid-svg-icons';
import { Schedule } from 'src/app/shared/models/schedule.model';
import { FormControl, FormGroup, FormArray } from '@angular/forms';
import { ScheduleTime } from 'src/app/shared/models/schedule-time.model';
import * as lodash from 'lodash';
import { ConfirmModalComponent } from 'src/app/shared/confirm-modal/confirm-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from 'src/app/shared/toast/toast.service';
import { TrainingSessionsService } from './training-sessions.service';
import * as  ScheduleValidator from '../../organizations/update-schedule/schedule.validator';

@Component({
    selector: 'app-update-training-sessions',
    templateUrl: './update-training-sessions.component.html',
    styleUrls: ['./update-training-sessions.component.css'],
    standalone: false
})
export class UpdateTrainingSessionsComponent implements OnInit, OnDestroy {

  @ViewChild('confirmModal') confirmModal: ConfirmModalComponent;
  @ViewChild('sectionToScroll') sectionToScroll: ElementRef;

  public currentOrganizationId: number;
  public scheduleAction: string;
  public icons: { [name: string]: any } = {
    'faCalendarAlt': faCalendarAlt,
    'faTimes': faTimes,
    'faLink': faLink
  };
  public schedules: Schedule[];
  public scheduleFormGroup: FormGroup;
  public scheduleDescriptionFormGroup: FormGroup;
  public orgType: string;

  constructor(private _activatedRoute: ActivatedRoute, private _router: Router, private _trainingSessionsService: TrainingSessionsService,
    private _translateService: TranslateService, private _toastService: ToastService) {
    this._initScheduleFormGroup();
    this.scheduleDescriptionFormGroup = new FormGroup({
      scheduleDescription_de: new FormControl(''),
      scheduleDescription_it: new FormControl(''),
      scheduleDescription_en: new FormControl('')
    });
  }

  ngOnInit(): void {
    const urlPramas = this._activatedRoute.snapshot.params;
    if (!urlPramas.orgId) {
      this._router.navigate(['/']);
    }
    this.currentOrganizationId = urlPramas.orgId;
    this.orgType = localStorage.getItem('orgId');
    this._trainingSessionsService.getSchedulesOfOrganiaztion(this.currentOrganizationId).subscribe(() => {
      this.schedules = this._trainingSessionsService.schedules;
      this.scheduleDescriptionFormGroup.patchValue(this._trainingSessionsService.scheduleDescriptions);
    }, error => {
      console.log(error);
    });

    this._trainingSessionsService.onScheduleEdit.subscribe(index => {
      console.log(index);
      this.cancelCurrentAction();
      this.scheduleAction = 'update';
      const currentSchedule: Schedule = lodash.cloneDeep(this._trainingSessionsService.schedules[index]);
      const patchedValues = this._parseServerObjectToFormObject(currentSchedule);
      this.scheduleFormGroup.get('id').setValue(patchedValues.id);
      this.scheduleFormGroup.get('fullYear').setValue(patchedValues.fullYear);
      this.scheduleFormGroup.get('startDate').setValue(patchedValues.startDate);
      this.scheduleFormGroup.get('endDate').setValue(patchedValues.endDate);
      this.scheduleFormGroup.get('name_it').setValue(patchedValues.name_it);
      this.scheduleFormGroup.get('name_de').setValue(patchedValues.name_de);
      this.scheduleFormGroup.get('name_en').setValue(patchedValues.name_en);
      for (let i = 0; i < patchedValues.scheduleTime.length; i++) {
        const element = patchedValues.scheduleTime[i];
        this.onAddTimeScheduleElement();
        const control = (<FormArray>this.scheduleFormGroup.get('scheduleTime')).controls[i];
        control.patchValue(element);
      }
      this.sectionToScroll.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    this._trainingSessionsService.onScheduleDelete.subscribe(index => {
      this.confirmModal.open(this._translateService.instant('ORGANIZATION.SCHEDULES.deleteScheduleTitle'), this._translateService.instant('ORGANIZATION.SCHEDULES.deleteScheduleDesc'));
      this.confirmModal.confirmationResult.subscribe(result => {
        if (result) {
          this._trainingSessionsService.deleteScheduleById(index).subscribe(() => {
            // TODO: SHOW SUCCESS MESSAGE
          }, error => {
            console.log(error);
          });
        }
        if (result) {
          console.log('DELETE');
        }
      });
    });

    this._trainingSessionsService.onSchedulesArrayChange.subscribe(() => {
      this.schedules = [];
      this.schedules = this._trainingSessionsService.schedules;
    });

    this.onFormChanges();
  }

  ngOnDestroy(): void {
    this.schedules = [];
  }

  onFormChanges(): void {
    this.scheduleFormGroup.get('fullYear').valueChanges.subscribe(result => {
      this.scheduleFormGroup.patchValue({
        'startDate': null,
        'endDate': null
      });
      this.scheduleFormGroup.get('startDate').setErrors(null);
      this.scheduleFormGroup.get('endDate').setErrors(null);
    });
  }

  onScheduleSubmit() {
    if (this.scheduleFormGroup.get('name_it').value === '' && this.scheduleFormGroup.get('name_en').value === ''
      && this.scheduleFormGroup.get('name_en').value === '') {
      this.scheduleFormGroup.setErrors({ 'emptyScheduleName': true });
      return;
    }
    console.log(this.scheduleFormGroup.get('name_it').value);
    if ((<FormArray>this.scheduleFormGroup.get('scheduleTime')).length === 0) {
      this.scheduleFormGroup.setErrors({ 'emptyScheduleTime': true });
      return;
    }
    if (this.scheduleFormGroup.valid) {
      const parsedSchedule = this._parseFormObjectToServerObject(this.scheduleFormGroup.value);
      this._trainingSessionsService.updateSchedule(parsedSchedule, this.currentOrganizationId.toString()).subscribe(() => {
        this._initScheduleFormGroup();
        this.scheduleAction = undefined;
        this._toastService.show('', {
          classname: 'bg-success text-light',
          delay: 2000,
          autohide: true,
        });
      }, error => {
        console.error(error);
      });
    } else {
      console.log(this.scheduleFormGroup.errors);
      console.log('ERROR');
    }
  }

  onScheduleDescriptionSubmit() {
    console.log(this.scheduleDescriptionFormGroup.value);
    this._trainingSessionsService.updateScheduleDescription(this.currentOrganizationId.toString(),
      this.scheduleDescriptionFormGroup.value).subscribe(result => {
        this._toastService.show('', {
          classname: 'bg-success text-light',
          delay: 2000,
          autohide: true,
        });
      });
  }

  cancelCurrentAction() {
    this.scheduleAction = undefined;
    this._initScheduleFormGroup();
  }

  onAddTimeScheduleElement() {
    const scheduleTimeFormGroup = new FormGroup({
      'id': new FormControl(''),
      'openingHour': new FormControl({ hour: 0, minute: 0 }, [(control: FormControl) => {
        if (control.value.hour === 0 && control.value.minute === 0) {
          return { 'openingHourRequired': true };
        }
        return null;
      }]),
      'closingHour': new FormControl({ hour: 0, minute: 0 }),
      // 'lunchStartHour': new FormControl({ hour: 0, minute: 0 }),
      // 'lunchEndHour': new FormControl({ hour: 0, minute: 0 }),
      'openingDays': new FormGroup({
        '1': new FormControl(false),
        '2': new FormControl(false),
        '3': new FormControl(false),
        '4': new FormControl(false),
        '5': new FormControl(false),
        '6': new FormControl(false),
        '7': new FormControl(false),
      })
    }, {
      validators: [
        // ScheduleValidator.checkLunchTimeStartValidator,
        // ScheduleValidator.checkLunchTimeEndValidator,
        ScheduleValidator.chekClosingHourValidator
      ]
    });
    (<FormArray>this.scheduleFormGroup.get('scheduleTime')).push(scheduleTimeFormGroup);
  }

  deleteScheduleTimeControl(index: number) {
    (<FormArray>this.scheduleFormGroup.get('scheduleTime')).removeAt(index);
  }

  getScheduleFormGruop(index: number): FormGroup {
    return this.scheduleFormGroup.get('scheduleTime')['controls'][index];
  }

  private _parseFormObjectToServerObject(object: any): any {
    for (const key in object) {
      if (Object.prototype.hasOwnProperty.call(object, key)) {
        const element = object[key];
        if (key === 'startDate' || key === 'endDate') {
          object[key] = (element ? Schedule.convertNgbDataStructureToDateString(element) : '');
        }
        if (key === 'scheduleTime') {
          element.forEach((scheduleTimeObject: { [x: string]: any; }) => {
            for (const j in scheduleTimeObject) {
              if (Object.prototype.hasOwnProperty.call(scheduleTimeObject, j)) {
                if (j === 'closingHour' || j === 'lunchEndHour' || j === 'lunchStartHour' || j === 'openingHour') {
                  scheduleTimeObject[j] = ScheduleTime.convertObjectToTimeString(scheduleTimeObject[j]);
                }
                if (j === 'openingDays') {
                  scheduleTimeObject[j] = ScheduleTime.convertDaysObjectToArray(scheduleTimeObject[j]);
                }
              }
            }
          });
        }
      }
    }
    return object;
  }

  private _parseServerObjectToFormObject(object: any): any {
    for (const key in object) {
      if (Object.prototype.hasOwnProperty.call(object, key)) {
        const element = object[key];
        if (key === 'startDate' || key === 'endDate') {
          object[key] = Schedule.convertDateToNgbDataStructure(element);
        }
        if (key === 'scheduleTime') {
          element.forEach((scheduleTimeObject: { [x: string]: any; }) => {
            for (const j in scheduleTimeObject) {
              if (Object.prototype.hasOwnProperty.call(scheduleTimeObject, j)) {
                if (j === 'closingHour' || j === 'lunchEndHour' || j === 'lunchStartHour' || j === 'openingHour') {
                  scheduleTimeObject[j] = ScheduleTime.convertStringToObject(scheduleTimeObject[j]);
                }
                if (j === 'openingDays') {
                  scheduleTimeObject[j] = ScheduleTime.convertDaysStringToObject(scheduleTimeObject[j]);
                }
              }
            }
          });
        }
      }
    }
    return object;
  }

  private _initScheduleFormGroup(): void {
    this.scheduleFormGroup = new FormGroup({
      id: new FormControl(''),
      startDate: new FormControl(),
      endDate: new FormControl(),
      fullYear: new FormControl(false),
      name_it: new FormControl(''),
      name_de: new FormControl(''),
      name_en: new FormControl(''),
      scheduleTime: new FormArray([])
    }, {
      validators: ScheduleValidator.checkStartEndScheduleDate
    });
  }

}
